import React from 'react';

const AppointmentDetails = ({ appointment, onClose }) => {
  if (!appointment) return null;

  const getStatusStyle = (status) => {
    switch(status) {
      case 'confirmed':
        return 'bg-green-100 text-green-800';
      case 'pending':
        return 'bg-yellow-100 text-yellow-800';
      case 'cancelled':
        return 'bg-red-100 text-red-800';
      case 'completed':
        return 'bg-blue-100 text-blue-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };

  return (
    <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50 flex items-center justify-center">
      <div className="relative mx-auto p-5 border w-full max-w-xl shadow-lg rounded-md bg-white">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-xl font-medium text-gray-900">Appointment Details</h3>
          <button 
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        <div className="space-y-4">
          <div className="border-b pb-3">
            <div className="flex justify-between">
              <span className="text-sm font-medium text-gray-500">Status</span>
              <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${getStatusStyle(appointment.status)}`}>
                {appointment.status}
              </span>
            </div>
          </div>
          
          <div className="grid grid-cols-2 gap-4">
            <div>
              <p className="text-sm font-medium text-gray-500">Patient</p>
              <p className="mt-1">{appointment.patient?.name || appointment.patientName}</p>
            </div>
            <div>
              <p className="text-sm font-medium text-gray-500">Doctor</p>
              <p className="mt-1">{appointment.doctor?.name || appointment.doctorName}</p>
            </div>
            <div>
              <p className="text-sm font-medium text-gray-500">Date</p>
              <p className="mt-1">{appointment.date}</p>
            </div>
            <div>
              <p className="text-sm font-medium text-gray-500">Time</p>
              <p className="mt-1">{appointment.time}</p>
            </div>
          </div>
          
          <div>
            <p className="text-sm font-medium text-gray-500">Reason for visit</p>
            <p className="mt-1">{appointment.reason}</p>
          </div>
          
          {appointment.diagnosis && (
            <div>
              <p className="text-sm font-medium text-gray-500">Diagnosis</p>
              <p className="mt-1">{appointment.diagnosis}</p>
            </div>
          )}
          
          {appointment.prescription && (
            <div>
              <p className="text-sm font-medium text-gray-500">Prescription</p>
              <p className="mt-1">{appointment.prescription}</p>
            </div>
          )}
          
          {appointment.notes && (
            <div>
              <p className="text-sm font-medium text-gray-500">Doctor's Notes</p>
              <p className="mt-1">{appointment.notes}</p>
            </div>
          )}

          <div className="flex justify-end pt-4">
            <button
              onClick={onClose}
              className="px-4 py-2 bg-gray-100 text-gray-800 rounded-md hover:bg-gray-200"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AppointmentDetails;
